import { render } from "./QuotePage.vue?vue&type=template&id=4718f646"
import script from "./QuotePage.vue?vue&type=script&lang=js"
export * from "./QuotePage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/Clients/visiontrust/vision-trust-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__